import { Component, OnInit } from '@angular/core';
import { PushNotificationService } from '@notification/push-notification.service';
import { ConfirmationDialogComponent } from '@common/confirmation-dialog/confirmation-dialog.component';
import { SelectNotificationDialogComponent } from '@common/select-notification-dialog/select-notification-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-send-notification',
  templateUrl: './send-notification.component.html',
  styleUrls: ['./send-notification.component.scss'],
  providers: [PushNotificationService],
})
export class SendNotificationComponent implements OnInit {
  constructor(
    private pushnotificationService: PushNotificationService,
    public dialog: MatDialog,
    private toastr: ToastrService
  ) {}

  notifications = [];

  ngOnInit() {
    this.readNotifications();
  }

  public readNotifications() {
    this.pushnotificationService.realAll().subscribe(
      (response) => {
        if (response) {
          this.notifications = response.data.list;
        }
      },
      (error) => {}
    );
  }

  public openDeleteNotificationDialog(notificationData) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      height: '207px',
      width: '486px',
      data: { value: notificationData , mode :'DELETE'},
    });
    dialogRef.afterClosed().subscribe((respose) => {
      if (respose.status) {
        const requestObj = {
          id: respose.data.id,
        };
        this.pushnotificationService.delete(requestObj).subscribe(
          (response) => {
            this.toastr.success(response.message);
            this.readNotifications();
          },
          (error) => {
            this.toastr.error(error.errorMessage);
          }
        );
      }
    });
  }

  public openSendNotificationDialog(tagInfo) {
    const dialogRef = this.dialog.open(SelectNotificationDialogComponent, {
      width: '600px',
      data: { value: tagInfo },
    });
  }
}
